import { Heading } from "@ariakit/react";
import type { ReactNode } from "react";
import { Fragment } from "react/jsx-runtime";
import { profileInfo } from "./style.css.ts";

type Stat = {
  label: string;
  value: string | number;
  action?: ReactNode;
};

type ProfileInfoProps = {
  cap?: ReactNode;
  name: string;
  type: string;
  stats: Stat[];
};

export function ProfileInfo(props: ProfileInfoProps) {
  const { name, type, stats, cap } = props;
  const isNameEqualToType = name === type;

  return (
    <div className={profileInfo.container}>
      <div className={profileInfo.header}>
        <div className={profileInfo.headerInfo}>
          {isNameEqualToType ? (
            <Heading className={profileInfo.name}>{name}</Heading>
          ) : (
            <>
              <div className={profileInfo.label}>{type}</div>
              <Heading className={profileInfo.name}>{name}</Heading>
            </>
          )}
        </div>

        {cap}
      </div>

      <div className={profileInfo.stats}>
        {stats.map((cell, i) => {
          return (
            <Fragment key={`${cell.label}-divider`}>
              {i !== 0 && <div className={profileInfo.divider} />}

              <div className={profileInfo.stat}>
                <div className={profileInfo.label}>{cell.label}</div>
                <div className={profileInfo.statValue}>
                  {cell.value}
                  {cell.action}
                </div>
              </div>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
